"use client";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

interface DevActivityBarChartProps {
  data: {
    name: string;
    slug: string;
    commits: number;
    prs: number;
    devs: number;
    score: number;
    imageUrl?: string | null;
  }[];
}

export function DevActivityBarChart({ data }: DevActivityBarChartProps) {
  if (!data.length) return null;

  return (
    <div className="w-full h-[400px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 10, right: 10, left: 0, bottom: 40 }}
          barCategoryGap="20%"
          barGap={2}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="rgba(255,255,255,0.05)"
            vertical={false}
          />
          <XAxis
            dataKey="name"
            tick={{ fill: "#9ca3af", fontSize: 11 }}
            angle={-35}
            textAnchor="end"
            height={60}
            axisLine={{ stroke: "rgba(255,255,255,0.08)" }}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: "#9ca3af", fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "hsl(230, 15%, 10%)",
              border: "1px solid hsl(230, 15%, 20%)",
              borderRadius: "12px",
              padding: "12px 16px",
              color: "#fff",
              fontSize: "13px",
            }}
            labelStyle={{ color: "#9ca3af", marginBottom: 4 }}
            cursor={{ fill: "rgba(255,255,255,0.03)" }}
          />
          <Legend
            verticalAlign="top"
            height={30}
            iconSize={10}
            iconType="rect"
            formatter={(value: string) => (
              <span className="text-xs text-gray-400">{value}</span>
            )}
          />
          <Bar
            dataKey="commits"
            name="Commits"
            fill="#3b82f6"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="prs"
            name="PRs Merged"
            fill="#06b6d4"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="devs"
            name="Active Devs"
            fill="#8b5cf6"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
